module.exports = __webpack_public_path__ + "static/32-7b001fcf724c4fa60589e9eafa614d9e.png";